import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { isImpersonationRuntimeEnabled } from '../../_services/impersonation-runtime';
import { VOUCHER_DEMO_STORAGE_KEY } from './voucher-demo.constants';

@Injectable({
	providedIn: 'root'
})
export class VoucherDemoModeService {
	private runtimeAllowed = !environment.production;
	private readonly enabledSubject = new BehaviorSubject<boolean>(
		this.runtimeAllowed && this.readFromStorage()
	);

	readonly enabled$: Observable<boolean> = this.enabledSubject.asObservable();

	/**
	 * Production Angular builds only honor the demo toggle on local/staging hosts.
	 * Call after config.json loads so a leftover localStorage flag cannot fire on prod.
	 */
	enableForRuntime(host: string, productionBuild: boolean = environment.production): void {
		this.runtimeAllowed = isImpersonationRuntimeEnabled(productionBuild, host);
		this.enabledSubject.next(this.runtimeAllowed && this.readFromStorage());
	}

	isEnabled(): boolean {
		return this.runtimeAllowed && this.enabledSubject.value;
	}

	setEnabled(enabled: boolean): void {
		if (enabled && !this.runtimeAllowed) {
			return;
		}
		if (typeof window !== 'undefined' && window.localStorage) {
			window.localStorage.setItem(VOUCHER_DEMO_STORAGE_KEY, enabled ? 'true' : 'false');
		}
		this.enabledSubject.next(this.runtimeAllowed && enabled);
	}

	private readFromStorage(): boolean {
		if (typeof window === 'undefined' || !window.localStorage) {
			return false;
		}
		return window.localStorage.getItem(VOUCHER_DEMO_STORAGE_KEY) === 'true';
	}
}
